export default __webpack_public_path__ + "static/media/InsideSkinHairNails_10.34683d61.png";